import { Button } from "antd";
import StandBy from "pages/classMode/etcpage/StandBy";
import React from "react";
import { FormattedMessage } from "react-intl";

const MvpPreview = (props) => {
  const { data, isKids, viewType, onChangeSummaryIndex } = props;
  if (isKids && viewType === "preview") {
    return <StandBy isKids={isKids} />;
  }
  return (
    <div className="mvp-preview-layout">
      <div className="mvp-preview-wrap">
        <Button
          type="primary"
          onClick={() => {
            onChangeSummaryIndex(10);
          }}
          size={"large"}
          style={{ background: "#13c2c2", borderColor: "#13c2c2" }}
        >
          <FormattedMessage id="classroom.move-to-mvp" />
        </Button>
      </div>
    </div>
  );
};
export default MvpPreview;
